import React from 'react';
import { Menu } from 'primereact/menu';
import { useBucketConfigration } from '../../../../Hooks/Features/Pocker/useBucketConfigration';
import CommonGrid from '../../../../components/CommonCompo/CommonGrid/CommonGrid';
import { TabPanel, TabView } from 'primereact/tabview';
import _ from 'underscore';
import { useCommon } from '../../../../Hooks/Common/useCommon';

const BucketConfigration = () => {
  const { columns, rowData, menuRef, selectedRow, getMenuItems, handleUpsertIssueType, loader, activeTab, setActiveTab, tabs, isChange, tagRef } = useBucketConfigration();
  const { checkPermission } = useCommon()


  return (
    <div ref={() => checkPermission("config", tagRef)}>
      <div ref={tagRef} id='{"tabname": "bucket_planning", "data": "agileplanning_bucket_configration"}' >
        <TabView activeIndex={activeTab?.index} onTabChange={(e) => { setActiveTab(_.find(tabs, { index: e.index })) }}>
          {tabs.map((tab) => {
            return (
              <TabPanel key={tab.title} header={tab.title} >
                <div style={{ height: "calc(100vh - 110px)", overflowY: "auto", overflowX: "hidden" }}>
                  <CommonGrid columns={columns} data={rowData} expandAll={true} loader={loader} rowHeight="auto"/>
                </div>
              </TabPanel>
            );
          })}
        </TabView>
        <Menu
          ref={menuRef}
          model={selectedRow ? getMenuItems(selectedRow) : []}
          popup
          className="survey-menu bucket-config"
          onHide={() => { handleUpsertIssueType(isChange) }}

        />
      </div>
    </div>
  );
}

export default BucketConfigration;
